import type {
  ButtonProps,
  IconButtonProps,
  ListItemButtonProps,
  LinkProps,
  MenuItemProps,
} from "@mui/material";
import {
  ListItemButton,
  MenuItem,
  Button as MuiButton,
  IconButton as MuiIconButton,
  Link as MuiLink,
} from "@mui/material";
import type { LinkComponent } from "@tanstack/react-router";
import { createLink } from "@tanstack/react-router";
import { forwardRef } from "react";

const MUILinkComponent = forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => (
  <MuiLink ref={ref} {...props} />
));

const CreatedLinkComponent = createLink(MUILinkComponent);

export const Link: LinkComponent<typeof MUILinkComponent> = (props) => {
  return <CreatedLinkComponent preload={"intent"} {...props} />;
};

const MUIButtonLinkComponent = forwardRef<HTMLAnchorElement, ButtonProps<"a">>((props, ref) => (
  <MuiButton ref={ref} component="a" {...props} />
));

const CreatedButtonLinkComponent = createLink(MUIButtonLinkComponent);

export const LinkButton: LinkComponent<typeof MUIButtonLinkComponent> = (props) => (
  <CreatedButtonLinkComponent preload={"intent"} {...props} />
);

const MUIMenuItemComponent = forwardRef<HTMLAnchorElement, MenuItemProps<"a">>((props, ref) => (
  <MenuItem component="a" ref={ref} {...props} />
));

const CreatedMenuItemComponent = createLink(MUIMenuItemComponent);

export const LinkMenuItem: LinkComponent<typeof MUIMenuItemComponent> = (props) => (
  <CreatedMenuItemComponent preload="intent" {...props} />
);

const MUIIconButtonLinkComponent = forwardRef<HTMLAnchorElement, IconButtonProps<"a">>(
  (props, ref) => <MuiIconButton ref={ref} component="a" {...props} />,
);

const CreatedIconButtonLinkComponent = createLink(MUIIconButtonLinkComponent);

export const LinkIconButton: LinkComponent<typeof MUIIconButtonLinkComponent> = (props) => (
  <CreatedIconButtonLinkComponent preload={"intent"} {...props} />
);

const MUIListItemButtonLinkComponent = forwardRef<HTMLAnchorElement, ListItemButtonProps<"a">>(
  (props, ref) => <ListItemButton ref={ref} component="a" {...props} />,
);

const CreatedListItemButtonLinkComponent = createLink(MUIListItemButtonLinkComponent);

export const LinkListItemButton: LinkComponent<typeof MUIListItemButtonLinkComponent> = (props) => (
  <CreatedListItemButtonLinkComponent preload={"intent"} {...props} />
);
